
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';



const SubNavbar = () => {

    const [activeTab, setActiveTab] = useState('photos');
    const TabLink = ({ to, tab, activeTab, label }) => (
        <li style={{ position: "relative" }}>
            <NavLink
                to={to}
                activeClassName="active"
                aria-current={activeTab === tab ? "page" : undefined}
            >
                {label}
            </NavLink>
        </li>
    );

    return (
        <div className="" style={{ marginTop: '140px' }}>
            <div className="container container-two">
                <ul className="nav-tabs nav tab-style-one" role="tablist">
                    <TabLink
                        to="/"
                        tab="photos"
                        activeTab={activeTab}
                        label="Photos"
                    />


                    <TabLink
                        to="/nextup"
                        tab="coming-up"
                        activeTab={activeTab}

                        label={
                            <>
                                Coming Up

                                <span className="ticker">New</span>

                            </>
                        }
                    />


                    <TabLink
                        to="/activity"
                        tab="activity"
                        activeTab={activeTab}
                        label="Activity"
                    />

                    <TabLink
                        to="/people"
                        tab="people"
                        activeTab={activeTab}
                        label="People"
                    />
                </ul>


            </div>
        </div>
    );
};



export default SubNavbar;